import React, { useCallback, useRef, useState } from 'react';
import { ChevronLeftIcon, ChevronRightIcon } from 'lucide-react';
import { insidePages } from '../data/insidePages';
import { OFFER_ANCHOR } from './constants';
export function LookInside() {
  const trackRef = useRef<HTMLDivElement>(null);
  const [active, setActive] = useState(0);
  const scrollTo = useCallback((index: number) => {
    const track = trackRef.current;
    if (!track) return;
    const clamped = Math.max(0, Math.min(insidePages.length - 1, index));
    track.scrollTo({
      left: clamped * track.clientWidth,
      behavior: 'smooth'
    });
    setActive(clamped);
  }, []);
  const handleScroll = () => {
    const track = trackRef.current;
    if (!track) return;
    const index = Math.round(track.scrollLeft / track.clientWidth);
    setActive(Math.max(0, Math.min(insidePages.length - 1, index)));
  };
  return <section className="bg-ev-black px-4 py-4 text-white" data-id="element-90" data-mp="190g8ps6mibu2">
      <div className="mx-auto max-w-4xl" data-id="element-91" data-mp="1dweqgwxg4vli">
        <h2 className="text-center font-display text-[21px] leading-tight text-white sm:text-3xl" data-id="element-92" data-mp="1dzj0wc1i8nkm">
          Look Inside
        </h2>
        <p className="mb-1 text-center font-cond text-lg tracking-wide text-ev-green sm:text-xl" data-id="element-93" data-mp="61m2w36jfdbq">
          Discover What&apos;s Inside EV &amp; HYBRID DIAGNOSTIC PRO™
        </p>
        <p className="mx-auto mb-3 max-w-2xl text-center text-[12px] font-medium leading-snug text-ev-steel sm:text-[14px]" data-id="element-94" data-mp="f1rbggngwhrh">
          EV &amp; hybrid system maps, battery and BMS references, motor and inverter diagrams,
          charging diagnostics, thermal-management systems, DTC interpretation, scan-data guidance
          and ready-to-use professional troubleshooting tools.
        </p>

        <div className="relative" data-id="element-95" data-mp="13sv55pl6b9c">
          <div ref={trackRef} onScroll={handleScroll} className="no-scrollbar flex snap-x snap-mandatory overflow-x-auto scroll-smooth rounded-lg" data-id="element-96" data-mp="3sgdslnbzlpra">
            {insidePages.map(page => <a key={page.src} href={OFFER_ANCHOR} className="w-full shrink-0 snap-center px-1" aria-label={`${page.caption} — go to the offer`} data-id="element-97" data-mp="2zrq47ivxyk9i">
                <img src={page.src} alt={page.caption} loading="lazy" className="mx-auto max-h-[68vh] w-auto max-w-full rounded-lg border-2 border-ev-panel object-contain" data-id="element-98" data-mp="1den2t0kqvwh1" />
              </a>)}
          </div>

          <button type="button" onClick={() => scrollTo(active - 1)} disabled={active === 0} aria-label="Previous page" className="absolute left-0 top-1/2 flex h-9 w-9 -translate-y-1/2 items-center justify-center rounded-full border-2 border-ev-green bg-ev-black/90 text-ev-green transition-opacity duration-150 ease-out disabled:opacity-30" data-id="element-99" data-mp="posr4mc5wdyd">
            <ChevronLeftIcon aria-hidden="true" className="h-5 w-5" data-id="element-100" data-mp="2a4e5vo73qryg" />
          </button>
          <button type="button" onClick={() => scrollTo(active + 1)} disabled={active === insidePages.length - 1} aria-label="Next page" className="absolute right-0 top-1/2 flex h-9 w-9 -translate-y-1/2 items-center justify-center rounded-full border-2 border-ev-green bg-ev-black/90 text-ev-green transition-opacity duration-150 ease-out disabled:opacity-30" data-id="element-101" data-mp="2k8kuyrrppxvi">
            <ChevronRightIcon aria-hidden="true" className="h-5 w-5" data-id="element-102" data-mp="21j5vh1rodgt8" />
          </button>
        </div>

        <p className="mt-2 text-center font-cond text-base tracking-wide text-ev-neon sm:text-lg" data-id="element-103" data-mp="1wii7yq2nni3r">
          {insidePages[active].caption}
        </p>
        <div className="mt-1.5 flex items-center justify-center gap-1.5" data-id="element-104" data-mp="1nile8a1ert1u">
          {insidePages.map((page, index) => <button key={page.src} type="button" onClick={() => scrollTo(index)} aria-label={`Go to page ${index + 1}`} aria-current={index === active} className={`h-2 rounded-full transition-[width,background-color] duration-150 ease-out ${index === active ? 'w-6 bg-ev-green' : 'w-2 bg-ev-steel/50'}`} data-id="element-105" data-mp="3lyhlskh7xvpq" data-mpi={index} />)}
        </div>
      </div>
    </section>;
}